module.exports = __webpack_public_path__ + "img/Restock.ID.30bd932b.png";